//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formPsw from './sub/form-psw';
import formCa from './sub/form-ca';

export default {
    props: [],
    components: { formPsw, formCa },
    data() {
        return {
            addressUrl: window.location.href,
            tabsController: '',
            logoUrl: '',
            logoShow: false,
            lImg: '',
        };
    },
    methods: {
        tabClickHandler(e) {
            setLocal('loginTabs', e.name);
        },
        getLastTabs() {
            this.tabsController = getLocal('loginTabs') || 'psw';
        },
    },
    created: function () {
        this.logoUrl = webInfo.logoUrl;
        this.lImg = webInfo.lImg;

        this.$nextTick(() => {
            this.logoShow = true;
        });
    },
    mounted: function () {
        this.$store.dispatch('clearUserInfo');

        this.getLastTabs();
    },
};
